var $568b8163f1e56faf$exports = {};
$568b8163f1e56faf$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0436\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u044F");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u0438");
      }
    }), " \u043D\u0430 \u0440\u0430\u0437\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0412\u044A\u0432\u0435\u0434\u0435\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u044F");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u0438");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438");
  }
};
export { $568b8163f1e56faf$exports as default };